import React, { useEffect, useState, useRef, useContext } from "react";
import Lottie from "react-lottie-player";
import FeatherIcon from "feather-icons-react";
import Xarrow from "react-xarrows";
import { NavLink, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { Helmet } from "react-helmet";
import translate from "../../shared/utils/translations";

const Home = ({ setPage }) => {
  let navigate = useNavigate();

  useEffect(() => {
    setPage("landing");
    currentLanguage(localStorage.getItem("lang") || "EN");
  });
  const box1Ref = useRef(null);
  const box2Ref = useRef(null);
  var settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  // const loggedInUser = useContext(UserContext);
  // useEffect(() => {
  //   console.log(loggedInUser);
  //   if (loggedInUser) {
  //     if (loggedInUser?.role === "admin") {
  //       navigate("/admin-dashboard");
  //     } else {
  //       navigate("/client-dashboard");
  //     }
  //   }
  // }, [loggedInUser]);
  const [currentLang, currentLanguage] = useState({});
  const [isTab, setTab] = useState("is-market");
  const [isMDL, showMDL] = useState(false);
  const [isIMG, setIMG] = useState("");
  return (
    <>
      <Helmet>
        <title>
          {translate("Kepicker - Start growing your Amazon account today!")}
        </title>
        <meta
          name="description"
          content={translate(
            "Say hello to Industry’s newest Asin extractor. Compare all Amazon marketplaces - increase leads with Kepicker. Let's find the most profitable products!"
          )}
        />
      </Helmet>

      <div className={`outer__inner home_m ${currentLang}`}>
        <div className="section main main_kpcker">
          <div className="main__center center">
            <div className="main__preview">
              <div className="img_area">
                <picture>
                  <img
                    src="/assets/img/world.png"
                    className="earth"
                    alt="World"
                  />
                  {/* <img
                    src="/assets/img/world_2.png"
                    className="earth empty"
                    alt="Main"
                  /> */}
                  {/* 
                  https://cobe-playground.vercel.app/ 
                  https://www.npmjs.com/package/cobe
                  https://www.cssscript.com/3d-globe-webgl/
                  */}
                  <div className="p_card" ref={box1Ref}>
                    <div className="left">
                      <div className="p_img"></div>

                      <div className="p_descs">
                        <div className="p_desc aa"></div>
                        <div className="p_desc bb"></div>
                      </div>
                    </div>

                    <div className="profit">
                      <span className="percentage_b green"></span>
                    </div>
                  </div>

                  <div className="p_card bb" ref={box2Ref}>
                    <div className="left">
                      <div className="p_img"></div>

                      <div className="p_descs">
                        <div className="p_desc aa"></div>
                        <div className="p_desc bb"></div>
                      </div>
                    </div>

                    <div className="profit">
                      <span className="percentage_b red"></span>
                    </div>
                  </div>

                  <Xarrow
                    start={box1Ref}
                    end="elem1"
                    strokeWidth={2}
                    showHead={false}
                    animateDrawing={true}
                    path="grid"
                    color="#23262F"
                    startAnchor={[
                      "right",
                      { position: "right", offset: { x: 10 } },
                    ]}
                  />

                  <Xarrow
                    start={box2Ref}
                    end="elem2"
                    strokeWidth={2}
                    showHead={false}
                    animateDrawing={true}
                    path="grid"
                    color="#23262F"
                    startAnchor={[
                      "right",
                      { position: "right", offset: { x: 10 } },
                    ]}
                  />

                  <div className="map_dots">
                    <div className="dot">
                      <div className="centraldot_elem" id="elem1"></div>
                      <div className="centraldot"></div>
                      <div className="wave"></div>
                      <div className="wave2"></div>
                    </div>
                    <div className="dot bb">
                      <div className="centraldot_elem" id="elem2"></div>
                      <div className="centraldot"></div>
                      <div className="wave"></div>
                      <div className="wave2"></div>
                    </div>
                  </div>

                  <div className="globe_all">
                    {currentLang === "TR" ? (
                      <>
                        Tüm
                        {/* <span className="amazon_b">
                          <img
                            src="/assets/img/map-icons/amazon.svg"
                            alt="Amazon svg icon"
                          ></img>
                        </span> */}{" "}
                        Amazon Pazar Yerlerini Karşılaştır
                        <br />
                        <span>
                          Kepicker ile Ürün Keşfinde
                          <br />
                          Yenilikçi Bir Adım Atın!
                        </span>
                      </>
                    ) : currentLang === "DE" ? (
                      <>
                        Vergleichen Sie alle
                        {/* <span className="amazon_b">
                          <img
                            src="/assets/img/map-icons/amazon.svg"
                            alt="Amazon svg icon"
                          ></img>
                        </span> */}{" "}
                        Amazon-Marktplätze
                        <br />
                        <span>
                          Nutzen Sie Amazon-Analysen von
                          <br />
                          auf der ganzen Welt.
                        </span>
                      </>
                    ) : (
                      <>
                        Compare All
                        {/* <span className="amazon_b">
                          <img
                            src="/assets/img/map-icons/amazon.svg"
                            alt="Amazon svg icon"
                          ></img>
                        </span> */}{" "}
                        Amazon Markets
                        <br />
                        <span>
                          Leverage Amazon analytics from
                          <br />
                          all over the globe.
                        </span>
                      </>
                    )}
                  </div>
                </picture>
              </div>
              <div className="main__wrap">
                <div className="main__info info bb under_lined">
                  {translate("Grow your Amazon Marketplace.")}
                </div>
                <h1 className="main__title hero ">
                  {translate("Kepicker Tools.")}
                </h1>
                <div className="main__info info mb_60">
                  {currentLang === "TR" ? (
                    <>
                      Ülkeler arası ürün ve fiyatları karşılaştırın -
                      <br />
                      <strong>Kepicker</strong> ile Satışlarınızı artırın.
                    </>
                  ) : currentLang === "DE" ? (
                    <>
                      Preise vergleichen und filtern -
                      <br />
                      Steigern Sie Ihren Umsatz mit <strong>Kepicker.</strong>
                    </>
                  ) : (
                    <>
                      Compare and filter prices -
                      <br />
                      Increase your revenue with <strong>Kepicker.</strong>
                    </>
                  )}
                </div>
                <NavLink className="button main__button" to="/signup">
                  {translate("Get Started")}
                </NavLink>
                <NavLink className="main__button iconic bordered" to="/about">
                  <span>{translate("Get to Know Us")}</span>{" "}
                  <FeatherIcon icon={"arrow-up-right"} />
                </NavLink>

                <div className="info_area hide__mm">
                  <div className="info_item">
                    <span className="big">2X</span>
                    <span className="small">
                      {translate("Potential to Reduce Time")}
                    </span>
                  </div>
                  <div className="info_item">
                    <span className="big">5+</span>
                    <span className="small">
                      {translate("Tools Ready Now")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section onex_w hero__img">
          <img
            className="desk_img"
            src="/assets/img/kepicker_tools.jpg"
            alt="Kepicker Tools"
          ></img>

          <Slider {...settings}>
            <div>
              <img src="/assets/img/ss_1.jpg" alt="Amazon Asin Extractor"></img>
            </div>
            <div>
              <img src="/assets/img/ss_2.jpg" alt="Amazon Asin SPY"></img>
            </div>
            <div>
              <img
                src="/assets/img/ss_3.jpg"
                alt="Compare Amazon Marketplaces"
              ></img>
            </div>
            <div>
              <img
                src="/assets/img/ss_4.jpg"
                alt="Amazon Product Fee and Price Calculator"
              ></img>
            </div>
          </Slider>
        </div>

        <div className="section onex_w">
          <div className="onex_w__center center big_w">
            <div className="onex_w__head">
              <h2 className="onex_w__title h2">
                {translate("Kepicker Tools & Main Features")}
              </h2>
              <div className="onex_w__info info">
                {translate("Do it easily, quickly and practically")} -<br />
                {translate(
                  "Premium features designed to help your business take-off"
                )}
                .
              </div>
            </div>
            <div className="onex_f__body">
              <div className="onex_f__list">
                <div className="onex_f__item t_1">
                  <div>
                    <div className="onex_w__subtitle">
                      <div className="icn__gg">
                        <span className="bf_wc"></span>
                        <span className="asin_ext ps__aaa"></span>
                      </div>
                      Asin Extractor
                    </div>
                    <div className="onex_w__content">
                      {translate(
                        "With this tool, you can quickly pull all Asins on the current page."
                      )}
                    </div>
                  </div>
                  <img
                    src="/assets/img/asin_extractor.png"
                    width="572"
                    sizes="(max-width: 767px) 95vw, (max-width: 991px) 572px, (max-width: 1439px) 42vw, 572px"
                    alt="Amazon Asin Extractor"
                  ></img>

                  <div className="glow"></div>
                </div>
                <div className="onex_f__item t_2">
                  <div>
                    <div className="onex_w__subtitle">
                      <div className="icn__gg">
                        <span className="bf_wc"></span>
                        <span className="asin_spy ps__aaa"></span>
                      </div>
                      Asin SPY
                    </div>
                    <div className="onex_w__content">
                      {translate(
                        "This tool becomes active while on the seller page. When this tool starts, it automatically runs in the background, page by page, and collects all the seller's Asins."
                      )}
                    </div>
                  </div>
                  <img
                    src="/assets/img/asin_spy.png"
                    width="572"
                    sizes="(max-width: 767px) 95vw, (max-width: 991px) 572px, (max-width: 1439px) 42vw, 572px"
                    alt="Amazon Asin SPY"
                  ></img>
                </div>
                <div className="onex_f__item t_3">
                  <div>
                    <div className="onex_w__subtitle">
                      <div className="icn__gg">
                        <span className="bf_wc"></span>
                        <span className="asin_cmp ps__aaa"></span>
                      </div>
                      {translate("Compare Marketplaces")}
                    </div>
                    <div className="onex_w__content">
                      {translate(
                        "It allows you to find the most profitable and suitable product by comparing the Asin lists you have drawn between two markets."
                      )}
                    </div>
                  </div>
                  <img
                    src="/assets/img/compare_marketplaces.png"
                    width="572"
                    sizes="(max-width: 767px) 95vw, (max-width: 991px) 572px, (max-width: 1439px) 42vw, 572px"
                    alt="Compare Amazon Marketplaces"
                  ></img>
                </div>
                <div className="onex_f__item t_4">
                  <div>
                    <div className="onex_w__subtitle">
                      <div className="icn__gg">
                        <span className="bf_wc"></span>
                        <span className="asin_pbi ps__aaa"></span>
                      </div>
                      {translate("Product Based Info")}
                    </div>
                    <div className="onex_w__content">
                      {translate(
                        "When you open a product page, it offers the Roi calculation and other price informations about the current product embedded in the page."
                      )}
                    </div>
                  </div>
                  <img
                    src="/assets/img/product_based_info.png"
                    width="572"
                    sizes="(max-width: 767px) 95vw, (max-width: 991px) 572px, (max-width: 1439px) 42vw, 572px"
                    alt="Amazon Product Based Info"
                  ></img>
                </div>
                <div className="onex_f__item t_5">
                  <div>
                    <div className="onex_w__subtitle">
                      <div className="icn__gg">
                        <span className="bf_wc"></span>
                        <span className="asin_cal ps__aaa"></span>
                      </div>
                      {translate("Kepicker Calculator")}
                    </div>
                    <div className="onex_w__content">
                      {translate(
                        "You can make your own calculations by manually entering the source and target market price and shipping price."
                      )}
                    </div>
                  </div>
                  <img
                    src="/assets/img/kepicker_calculator.png"
                    width="572"
                    sizes="(max-width: 767px) 95vw, (max-width: 991px) 572px, (max-width: 1439px) 42vw, 572px"
                    alt="Amazon Product Fee and Price Calculator"
                  ></img>
                </div>
                <div className="onex_f__item t_6">
                  <div>
                    <div className="onex_w__subtitle">
                      <div className="icn__gg">
                        <span className="bf_wc"></span>
                        <span className="asin_uploader ps__aaa"></span>
                      </div>
                      {translate("Uploader Tool")}
                    </div>
                    <div className="onex_w__content">
                      {translate(
                        "Do you have a file containing the Asin list? You can compare products by uploading your file to this tool."
                      )}
                    </div>
                  </div>
                  <img
                    src="/assets/img/wholesaler_tool.png"
                    width="572"
                    sizes="(max-width: 767px) 95vw, (max-width: 991px) 572px, (max-width: 1439px) 42vw, 572px"
                    alt="Amazon Wholesaler Tool"
                  ></img>
                </div>
                <div className="onex_f__item t_7">
                  <div>
                    <div className="onex_w__subtitle">
                      <div className="icn__gg">
                        <span className="bf_wc"></span>
                        <span className="stock_fetcher ps__aaa"></span>
                      </div>
                      {translate("Stock Fetcher")}
                    </div>
                    <div className="onex_w__content">
                      {translate(
                        "With this tool, you can get detailed stock data of a product."
                      )}
                    </div>
                  </div>
                  <img
                    src="/assets/img/stock_fetcher.png"
                    width="572"
                    sizes="(max-width: 767px) 95vw, (max-width: 991px) 572px, (max-width: 1439px) 42vw, 572px"
                    alt="Amazon Stock Fetcher Tool"
                  ></img>
                </div>
                <div className="onex_f__item t_8">
                  <div>
                    <div className="onex_w__subtitle">
                      <div className="icn__gg">
                        <span className="bf_wc"></span>
                        <span className="historical_data ps__aaa"></span>
                      </div>
                      {translate("Historical Data")}
                    </div>
                    <div className="onex_w__content">
                      {translate(
                        "With this tool, you can see detailed information of historical Keepa data for a product."
                      )}
                    </div>
                  </div>
                  <img
                    src="/assets/img/historical_data.png"
                    width="572"
                    sizes="(max-width: 767px) 95vw, (max-width: 991px) 572px, (max-width: 1439px) 42vw, 572px"
                    alt="Amazon Stock Fetcher Tool"
                  ></img>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section kpc_dd coming__fetaures">
          <div className="kpc_dd__center center">
            <div className="kpc_dd__head">
              <h2 className="kpc_dd__title h2">
                {translate("Coming Soon Features & Tools")}
              </h2>
              <div className="kpc_dd__info info">
                {translate(
                  "We will continue to improve the extension and add newer features to the extension."
                )}
                <br />
                {translate("Check out our upcoming updates.")}
              </div>
            </div>

            <div className="features__area">
              <div className="features__itm t_1">
                <div className="features_w__subtitle">
                  <div className="features_w__tags">
                    <span className="c_google_sheet"></span>
                    <span className="ff__tag ff">{translate("Feature")}</span>
                  </div>
                  <div className="itm__title">
                    {translate("Asins to Google Sheet")}
                  </div>
                </div>
                <div className="features_w__content">
                  {translate(
                    "You will be able to send the Asin lists you find to your Google Sheet account."
                  )}
                </div>
              </div>
              <div className="features__itm t_1">
                <div className="features_w__subtitle">
                  <div className="features_w__tags">
                    <span className="c_product_r"></span>
                    <span className="ff__tag tt">{translate("Tool")}</span>
                  </div>
                  <div className="itm__title">
                    {translate("Product Recommendation")}
                  </div>
                </div>
                <div className="features_w__content">
                  {translate(
                    "Our advanced algorithm will be able to recommend you a product with high sales potential every day."
                  )}
                </div>
              </div>
              <div className="features__itm t_1">
                <div className="features_w__subtitle">
                  <div className="features_w__tags">
                    <span className="c_product_o"></span>
                    <span className="ff__tag ff">{translate("Feature")}</span>
                  </div>
                  <div className="itm__title">
                    {translate("New Product Options")}
                  </div>
                </div>
                <div className="features_w__content">
                  <ul>
                    <li>
                      {translate(
                        "You will soon be able to add the products you find to your favorite lists."
                      )}
                    </li>
                    <li>
                      {translate(
                        "You will be able to add a note about the product you want."
                      )}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="features__itm t_1">
                <div className="features_w__subtitle">
                  <div className="features_w__tags">
                    <span className="c_wholesaler"></span>
                    <span className="ff__tag tt">{translate("Tool")}</span>
                  </div>
                  <div className="itm__title">
                    {translate("Wholesaler Tool")}
                  </div>
                </div>
                <div className="features_w__content">
                  <strong>{translate("Compare UPC + EAN Listings")} -</strong>{" "}
                  {translate(
                    "You will soon be able to compare EAC and UPC listings as well."
                  )}
                </div>
              </div>
              <div className="features__itm t_1">
                <div className="features_w__subtitle">
                  <div className="features_w__tags">
                    <span className="c_comparison"></span>
                    <span className="ff__tag ff">{translate("Feature")}</span>
                  </div>
                  <div className="itm__title">
                    {translate("More Advanced Comparison")}
                  </div>
                </div>
                <div className="features_w__content">
                  <ul>
                    <li>
                      {translate("Comparison with detailed discount types")}
                    </li>
                    <li>
                      {translate(
                        "Customization Table Columns (Coloring / Show / Hide)"
                      )}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="features__itm t_1"></div>
            </div>
          </div>
        </div>

        <div className="section kpc_dd promo_cn">
          <div className="kpc_dd__center center">
            <div className="kpc_dd__head">
              <h2 className="kpc_dd__title h2">
                {translate(
                  "Kepicker empowers to find better products, faster."
                )}
              </h2>
              <div className="kpc_dd__info info">
                {translate(
                  "The all-in-one finding and comparing products platform that saves you time + money. Most comparison sites provide basic information, with Kepicker, we want to help you research the most profitable products. That way we can focus on providing you with the best user experience, service, and settlement."
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="section onex_pl cmp_anim">
          <div className="onex_pl__center center pos_rel">
            <div className="onex_pl__wrap">
              <div className="stage">
                {translate("Boost your productivity!")}
              </div>
              <h2 className="onex_pl__title h2">
                {translate("Kepicker Will Offer You the Following.")}
              </h2>
              <div className="onex_pl__info">
                {translate(
                  "The app offers all the basic features you'll need for product research."
                )}
              </div>
              {currentLang === "TR" ? (
                <>
                  <ul className="checked_items">
                    <li>
                      <div>
                        Tüm <strong>Amazon pazar yerlerini</strong>{" "}
                        karşılaştırın.
                      </div>
                    </li>
                    <li>
                      <div>
                        Diğer eklentilere kıyasla{" "}
                        <strong>daha hızlı ASIN çekin.</strong>
                      </div>
                    </li>
                    <li>
                      <div>
                        <strong>2 mağazayı</strong> ASIN listeniz ile
                        karşılaştırın.
                      </div>
                    </li>
                    <li>
                      <div>
                        Arama sonuçlarından <strong>ASIN toplayın.</strong>
                      </div>
                    </li>
                    <li>
                      <div>
                        Mevcut ürünler ilgili <strong>rakip satıcıları</strong>{" "}
                        bulun.
                      </div>
                    </li>
                  </ul>
                </>
              ) : currentLang === "DE" ? (
                <>
                  <ul className="checked_items">
                    <li>
                      <div>
                        Vergleichen Sie <strong>alle Amazon-Marktplätze</strong>
                        .
                      </div>
                    </li>
                    <li>
                      <div>
                        <strong>Rufen Sie Asins</strong> schneller ab als andere
                        Erweiterungen.
                      </div>
                    </li>
                    <li>
                      <div>
                        Vergleichen <strong>Sie 2 Geschäfte</strong> mit Asin
                        List.
                      </div>
                    </li>
                    <li>
                      <div>
                        Rufen Sie Asins aus{" "}
                        <strong>den Suchergebnissen ab.</strong>
                      </div>
                    </li>
                    <li>
                      <div>
                        Finden Sie <strong>konkurrierende Verkäufer</strong> der
                        Produkte.
                      </div>
                    </li>
                  </ul>
                </>
              ) : (
                <>
                  <ul className="checked_items">
                    <li>
                      <div>
                        Compare <strong>all Amazon Marketplaces.</strong>
                      </div>
                    </li>
                    <li>
                      <div>
                        Fetch Asins{" "}
                        <strong>Faster than Other Extensions.</strong>
                      </div>
                    </li>
                    <li>
                      <div>
                        Compare <strong>2 Stores</strong> with Asin List.
                      </div>
                    </li>
                    <li>
                      <div>
                        Fetch Asins from the <strong>Search Results.</strong>
                      </div>
                    </li>
                    <li>
                      <div>
                        Find <strong>Competing Sellers</strong> of the Products.
                      </div>
                    </li>
                  </ul>
                </>
              )}
            </div>
            <div className="onex_pl__gallery xx">
              <div className="wrapper_slider">
                <div className="outer_slider">
                  <div className="card_slider" style={{ "--delay": "-1" }}>
                    <div className="content_slider">
                      <div className="img"></div>
                      <div className="details_slider">
                        <span className="name">
                          {translate("Custom Product")} #143
                        </span>
                        <p>
                          {translate("United Kingdom")} &#8594;{" "}
                          {translate("United States")}
                        </p>
                        <div className="bar_b"></div>
                        <div className="bar_s"></div>
                      </div>
                    </div>
                    <div className="profit">
                      <span className="percentage_b green">11%</span>
                      <span className="title">Roi</span>
                    </div>
                  </div>
                  <div className="card_slider" style={{ "--delay": "0" }}>
                    <div className="content_slider">
                      <div className="img"></div>
                      <div className="details_slider">
                        <span className="name">
                          {translate("Custom Product")} #345
                        </span>
                        <p>{translate("United States")} &#8594; Türkiye</p>
                        <div className="bar_b"></div>
                        <div className="bar_s"></div>
                      </div>
                    </div>
                    <div className="profit">
                      <span className="percentage_b red">-5%</span>
                      <span className="title">Roi</span>
                    </div>
                  </div>
                  <div className="card_slider" style={{ "--delay": "1" }}>
                    <div className="content_slider">
                      <div className="img"></div>
                      <div className="details_slider">
                        <span className="name">
                          {translate("Custom Product")} #221
                        </span>
                        <p>Türkiye &#8594; {translate("Canada")}</p>
                        <div className="bar_b"></div>
                        <div className="bar_s"></div>
                      </div>
                    </div>
                    <div className="profit">
                      <span className="percentage_b green">32%</span>
                      <span className="title">Roi</span>
                    </div>
                  </div>
                  <div className="card_slider" style={{ "--delay": "2" }}>
                    <div className="content_slider">
                      <div className="img"></div>
                      <div className="details_slider">
                        <span className="name">
                          {translate("Custom Product")} #754
                        </span>
                        <p>
                          {translate("Germany")} &#8594; {translate("Canada")}
                        </p>
                        <div className="bar_b"></div>
                        <div className="bar_s"></div>
                      </div>
                    </div>
                    <div className="profit">
                      <span className="percentage_b green">4%</span>
                      <span className="title">Roi</span>
                    </div>
                  </div>
                  <div className="card_slider" style={{ "--delay": "2" }}>
                    <div className="content_slider">
                      <div className="img"></div>
                      <div className="details_slider">
                        <span className="name">
                          {translate("Custom Product")} #085
                        </span>
                        <p>
                          {translate("Canada")} &#8594;{" "}
                          {translate("United Kingdom")}
                        </p>
                        <div className="bar_b"></div>
                        <div className="bar_s"></div>
                      </div>
                    </div>
                    <div className="profit">
                      <span className="percentage_b red">-8%</span>
                      <span className="title">Roi</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section onex_pl cmp_anim extesinon__area">
          <div className="onex_pl__center center pos_rel">
            <div className="onex_pl__wrap">
              <div className="stage">
                {translate(
                  "All-in-One Amazon Analytics and Product Research Hub!"
                )}
              </div>
              <h2 className="onex_pl__title h2">
                {translate(
                  "Kepicker Showcase: Advanced Tools for Amazon Sellers"
                )}
              </h2>
              <div className="onex_pl__info">
                {translate(
                  "Maximize Profits. Minimize Effort. Navigate. Analyze. Excel."
                )}
              </div>
              <div className="tabs___ext hd__mbl">
                <ul>
                  <li>
                    <button
                      className={`${isTab === "is-market" ? "active" : ""}`}
                      onClick={() => setTab("is-market")}
                    >
                      {translate("Market Comparison")}
                    </button>
                  </li>
                  <li>
                    <button
                      className={`${isTab === "is-stock" ? "active" : ""}`}
                      onClick={() => setTab("is-stock")}
                    >
                      {translate("Seller's Stock Fetcher")}
                    </button>
                  </li>
                  <li>
                    <button
                      className={`${isTab === "is-additional" ? "active" : ""}`}
                      onClick={() => setTab("is-additional")}
                    >
                      {translate("Additional Product Infos")}
                    </button>
                  </li>
                  <li>
                    <button
                      className={`${isTab === "is-keepa" ? "active" : ""}`}
                      onClick={() => setTab("is-keepa")}
                    >
                      {translate("Historical Data (Keepa)")}
                    </button>
                  </li>
                </ul>
              </div>

              {isTab === "is-market" ? (
                <p className="hd__mbl">
                  {translate(
                    "Kepicker's Market Comparison feature allows users to identify the most profitable and suitable products by comparing Asin lists across different Amazon markets. This tool facilitates strategic decision-making for maximizing revenue on Amazon."
                  )}
                </p>
              ) : (
                <></>
              )}

              {isTab === "is-stock" ? (
                <p className="hd__mbl">
                  {translate(
                    "The Seller's Stock Fetcher feature in Kepicker enables users to obtain detailed stock information for a product. This tool is essential for managing inventory levels and making informed purchasing decisions."
                  )}
                </p>
              ) : (
                <></>
              )}

              {isTab === "is-additional" ? (
                <p className="hd__mbl">
                  {translate(
                    "The Additional Product Infos feature in Kepicker provides users with ROI calculations and other crucial pricing details embedded directly on the Amazon product page. This tool aids in making informed decisions by offering immediate financial insights into products."
                  )}
                </p>
              ) : (
                <></>
              )}

              {isTab === "is-keepa" ? (
                <p className="hd__mbl">
                  {translate(
                    "The Historical Data (Keepa) feature in Kepicker allows users to access essential historical Keepa data for products, offering insights into price changes and trends over time. This tool is invaluable for strategizing pricing and understanding market dynamics."
                  )}
                </p>
              ) : (
                <></>
              )}

              <div className="show_ui_Area">
                <ul>
                  <li>
                    <button
                      onClick={() => {
                        showMDL(true);
                        setIMG("is-asin");
                      }}
                      className={`show_ui_btn`}
                    >
                      <span>{translate("Show ASIN List")}</span>
                      <FeatherIcon icon={"arrow-up-right"} />
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => {
                        showMDL(true);
                        setIMG("is-comparison");
                      }}
                      className={`show_ui_btn`}
                    >
                      <span>{translate("Show Comparison Result")}</span>
                      <FeatherIcon icon={"arrow-up-right"} />
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => {
                        showMDL(true);
                        setIMG("is-seller");
                      }}
                      className={`show_ui_btn`}
                    >
                      <span>{translate("Show Seller Data")}</span>
                      <FeatherIcon icon={"arrow-up-right"} />
                    </button>
                  </li>
                </ul>
              </div>

              <div className="amazon__extensn">
                {currentLang === "EN" ? (
                  <img src="/assets/img/amazon_extension/en.png"></img>
                ) : (
                  <></>
                )}
                {currentLang === "TR" ? (
                  <img src="/assets/img/amazon_extension/tr.png"></img>
                ) : (
                  <></>
                )}
                {currentLang === "DE" ? (
                  <img src="/assets/img/amazon_extension/de.png"></img>
                ) : (
                  <></>
                )}
              </div>

              <div className={`img__modal_area ${isMDL && " active"}`}>
                <button
                  onClick={() => {
                    showMDL(false);
                    setIMG("");
                  }}
                  className={`close_ui_btn`}
                >
                  <FeatherIcon icon={"x"} />
                </button>
                <div className={`img__modal_body ${currentLang}`}>
                  <img
                    className={`en is-as ${isIMG}`}
                    src="/assets/img/amazon_asin_list/en.png"
                  ></img>
                  <img
                    className={`en is-cmp ${isIMG}`}
                    src="/assets/img/compare_products/en.PNG"
                  ></img>
                  <img
                    className={`en is-sllr ${isIMG}`}
                    src="/assets/img/amazon_seller_data/en.png"
                  ></img>

                  <img
                    className={`tr is-as ${isIMG}`}
                    src="/assets/img/amazon_asin_list/tr.png"
                  ></img>
                  <img
                    className={`tr is-cmp ${isIMG}`}
                    src="/assets/img/compare_products/tr.PNG"
                  ></img>
                  <img
                    className={`tr is-sllr ${isIMG}`}
                    src="/assets/img/amazon_seller_data/tr.png"
                  ></img>

                  <img
                    className={`de is-as ${isIMG}`}
                    src="/assets/img/amazon_asin_list/de.png"
                  ></img>
                  <img
                    className={`de is-cmp ${isIMG}`}
                    src="/assets/img/compare_products/de.PNG"
                  ></img>
                  <img
                    className={`de is-sllr ${isIMG}`}
                    src="/assets/img/amazon_seller_data/de.png"
                  ></img>
                </div>
              </div>
            </div>

            <div className="onex_pl__extesinon__area">
              <div className="pbi__infos">
                <div className="pbi__info">
                  <div className="kc_icn_skull"></div>
                  <span>{translate("Hazmat Product")}</span>
                </div>
                <div className="pbi__info">
                  <div className="kc_icn_vari"></div>
                  <span>{translate("Variation Product")}</span>
                </div>
              </div>

              <div className="pbi__Area">
                <div className="pbi_top">
                  {currentLang === "EN" ? (
                    <img src="/assets/img/amazon_product_research/top/en.PNG"></img>
                  ) : (
                    <></>
                  )}
                  {currentLang === "TR" ? (
                    <img src="/assets/img/amazon_product_research/top/tr.PNG"></img>
                  ) : (
                    <></>
                  )}
                  {currentLang === "DE" ? (
                    <img src="/assets/img/amazon_product_research/top/de.PNG"></img>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="pbi_tabs">
                  <div className="tabs___ext">
                    <ul>
                      <li>
                        <button
                          className={`${isTab === "is-market" ? "active" : ""}`}
                          onClick={() => setTab("is-market")}
                        >
                          {translate("Market Comparison")}
                        </button>
                      </li>
                      <li>
                        <button
                          className={`${isTab === "is-stock" ? "active" : ""}`}
                          onClick={() => setTab("is-stock")}
                        >
                          {translate("Seller's Stock Fetcher")}
                        </button>
                      </li>
                      <li>
                        <button
                          className={`${
                            isTab === "is-additional" ? "active" : ""
                          }`}
                          onClick={() => setTab("is-additional")}
                        >
                          {translate("Additional Product Infos")}
                        </button>
                      </li>
                      <li>
                        <button
                          className={`${isTab === "is-keepa" ? "active" : ""}`}
                          onClick={() => setTab("is-keepa")}
                        >
                          {translate("Historical Data (Keepa)")}
                        </button>
                      </li>
                    </ul>
                  </div>

                  {isTab === "is-market" ? (
                    <p className="sh__mbl">
                      {translate(
                        "Kepicker's Market Comparison feature allows users to identify the most profitable and suitable products by comparing Asin lists across different Amazon markets. This tool facilitates strategic decision-making for maximizing revenue on Amazon."
                      )}
                    </p>
                  ) : (
                    <></>
                  )}

                  {isTab === "is-stock" ? (
                    <p className="sh__mbl">
                      {translate(
                        "The Seller's Stock Fetcher feature in Kepicker enables users to obtain detailed stock information for a product. This tool is essential for managing inventory levels and making informed purchasing decisions."
                      )}
                    </p>
                  ) : (
                    <></>
                  )}

                  {isTab === "is-additional" ? (
                    <p className="sh__mbl">
                      {translate(
                        "The Additional Product Infos feature in Kepicker provides users with ROI calculations and other crucial pricing details embedded directly on the Amazon product page. This tool aids in making informed decisions by offering immediate financial insights into products."
                      )}
                    </p>
                  ) : (
                    <></>
                  )}

                  {isTab === "is-keepa" ? (
                    <p className="sh__mbl">
                      {translate(
                        "The Historical Data (Keepa) feature in Kepicker allows users to access essential historical Keepa data for products, offering insights into price changes and trends over time. This tool is invaluable for strategizing pricing and understanding market dynamics."
                      )}
                    </p>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="pbi_bottom">
                  {currentLang === "EN" ? (
                    <>
                      {isTab === "is-market" ? (
                        <img src="/assets/img/amazon_product_research/bottom/01/en.PNG"></img>
                      ) : (
                        <></>
                      )}
                      {isTab === "is-stock" ? (
                        <img src="/assets/img/amazon_product_research/bottom/02/en.PNG"></img>
                      ) : (
                        <></>
                      )}
                      {isTab === "is-additional" ? (
                        <img src="/assets/img/amazon_product_research/bottom/03/en.PNG"></img>
                      ) : (
                        <></>
                      )}
                      {isTab === "is-keepa" ? (
                        <img src="/assets/img/amazon_product_research/bottom/04/en.PNG"></img>
                      ) : (
                        <></>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                  {currentLang === "TR" ? (
                    <>
                      {isTab === "is-market" ? (
                        <img src="/assets/img/amazon_product_research/bottom/01/tr.PNG"></img>
                      ) : (
                        <></>
                      )}
                      {isTab === "is-stock" ? (
                        <img src="/assets/img/amazon_product_research/bottom/02/tr.PNG"></img>
                      ) : (
                        <></>
                      )}
                      {isTab === "is-additional" ? (
                        <img src="/assets/img/amazon_product_research/bottom/03/tr.PNG"></img>
                      ) : (
                        <></>
                      )}
                      {isTab === "is-keepa" ? (
                        <img src="/assets/img/amazon_product_research/bottom/04/tr.PNG"></img>
                      ) : (
                        <></>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                  {currentLang === "DE" ? (
                    <>
                      {isTab === "is-market" ? (
                        <img src="/assets/img/amazon_product_research/bottom/01/de.PNG"></img>
                      ) : (
                        <></>
                      )}
                      {isTab === "is-stock" ? (
                        <img src="/assets/img/amazon_product_research/bottom/02/de.PNG"></img>
                      ) : (
                        <></>
                      )}
                      {isTab === "is-additional" ? (
                        <img src="/assets/img/amazon_product_research/bottom/03/de.PNG"></img>
                      ) : (
                        <></>
                      )}
                      {isTab === "is-keepa" ? (
                        <img src="/assets/img/amazon_product_research/bottom/04/de.PNG"></img>
                      ) : (
                        <></>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section view">
          <div className="view__center center promo_sc">
            <div className="view__head">
              <div className="view__details">
                <div className="view__stage">
                  {translate("Ready to get started?")}
                </div>
                <h2 className="view__title h2">
                  {translate("Let's do it. Let's find!")}
                </h2>
                <p className="onex_p__info info">
                  {translate("Say hello to Industry’s newest product finder.")}
                </p>
              </div>
              <NavLink className="button view__button" to="/signup">
                {translate("Get Early Access")}
              </NavLink>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-push">
        <div className="footer-push-content section-width">
          <div className="item how">
            <div className="icon"></div>
            <div className="text">
              <h3>{translate("Guides, Articles & Tips")}</h3>
              <p>
                {translate(
                  "Here our blogs provide some tips and guides for you to find the best products for your marketplace."
                )}
              </p>
              <NavLink to="/blog" className="tertiary-cta ">
                {" "}
                {translate("Latest News ‍& Updates")}{" "}
              </NavLink>
            </div>
          </div>
          <div className="item faq">
            <div className="icon"></div>
            <div className="text">
              <h3>{translate("Help Center")}</h3>
              <p>
                {translate(
                  "Contact us to learn how we can help your business or get answer to technical questions about Kepicker."
                )}{" "}
              </p>
              <NavLink to="/support" className="tertiary-cta ">
                {" "}
                {translate("Browse the help center")}{" "}
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
